import React, { useEffect, useState } from "react";
import "../OpsShared.css";
import { listTechnicians } from "../../../api/schedulingApi";
import { Table, THead, TRow, TCell, TStatus, TEmpty } from "../../ui/table";

const ROLE_LABELS = { tech: "Technician", rep: "Sales Rep", manager: "Manager" };

export default function TechniciansPage() {
  const [techs, setTechs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    listTechnicians()
      .then((res) => {
        if (cancelled) return;
        const rows = Array.isArray(res.data) ? res.data : res.data?.results || [];
        setTechs(rows);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Failed to load technicians");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const active = techs.filter((t) => t.is_active);
  const inactive = techs.filter((t) => !t.is_active);

  return (
    <div className="ops-page">
      <header className="ops-head">
        <div>
          <h1>Technicians & Staff</h1>
          <p className="ops-muted">Roster, performance, and daily workload coverage.</p>
        </div>
        <div className="ops-actions">
          <button className="ops-btn secondary">Upload Roster</button>
          <button className="ops-btn">Add Technician</button>
        </div>
      </header>

      <section className="ops-stat-grid">
        <div className="ops-stat">
          <div className="label">Active Technicians</div>
          <div className="value">{loading ? "—" : active.length}</div>
        </div>
        <div className="ops-stat">
          <div className="label">Inactive / On Leave</div>
          <div className="value">{loading ? "—" : inactive.length}</div>
        </div>
        <div className="ops-stat">
          <div className="label">Total Staff</div>
          <div className="value">{loading ? "—" : techs.length}</div>
        </div>
      </section>

      {error && <div className="ops-error" style={{ color: "var(--color-danger)", padding: "1rem" }}>{error}</div>}

      <section className="ops-card">
        <div className="ops-card-head">
          <h3>Team Roster</h3>
          <button className="ops-btn ghost">View Scheduling Coverage</button>
        </div>
        <Table>
          <THead columns={["ID", "Name", "Role", "Region", "Status", { label: "Score", align: "right" }]} />
          <tbody>
            {loading ? (
              <TEmpty colSpan={6}>Loading…</TEmpty>
            ) : techs.length === 0 ? (
              <TEmpty colSpan={6}>No technicians found. Add staff or sync from FieldRoutes.</TEmpty>
            ) : (
              techs.map((tech) => (
                <TRow key={tech.id}>
                  <TCell className="mono">{tech.id}</TCell>
                  <TCell>{tech.user_name || "—"}</TCell>
                  <TCell>{ROLE_LABELS[tech.role_type] || tech.role_type || "—"}</TCell>
                  <TCell>{(tech.service_areas || []).join(", ") || "—"}</TCell>
                  <TCell>
                    <TStatus status={tech.is_active ? "success" : "warning"}>
                      {tech.is_active ? "Active" : "Inactive"}
                    </TStatus>
                  </TCell>
                  <TCell align="right">
                    {tech.performance_score != null ? Number(tech.performance_score).toFixed(1) : "—"}
                  </TCell>
                </TRow>
              ))
            )}
          </tbody>
        </Table>
      </section>
    </div>
  );
}
